/* M22 Challenge: registration state, countdown, Klaviyo sign-up, course tabs, accordions */
(function () {
  if (window.__m22c) return; window.__m22c = 1;

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function initCta(el) {
    var mode = el.getAttribute('data-mode') || 'auto';
    var openAt = Date.parse(el.getAttribute('data-open'));
    var q = new URLSearchParams(location.search).get('mc_state');
    if (q) mode = q; /* preview helper: ?mc_state=soon|open|full */
    function show(state) {
      el.setAttribute('data-state', state);
      el.querySelectorAll('[data-when]').forEach(function (n) { n.hidden = n.getAttribute('data-when') !== state; });
    }
    if (mode === 'full') return show('full');
    if (mode === 'open' || (mode === 'auto' && !isNaN(openAt) && Date.now() >= openAt)) return show('open');
    if (mode === 'soon' || mode === 'auto') {
      show('soon');
      var c = el.querySelector('[data-mc-count]');
      if (!c || isNaN(openAt)) return;
      var u = {}; c.querySelectorAll('[data-u]').forEach(function (b) { u[b.getAttribute('data-u')] = b; });
      (function tick() {
        var ms = openAt - Date.now();
        if (ms <= 0) { show('open'); return; }
        var s = Math.floor(ms / 1000);
        u.d.textContent = Math.floor(s / 86400);
        u.h.textContent = pad(Math.floor(s % 86400 / 3600));
        u.m.textContent = pad(Math.floor(s % 3600 / 60));
        u.s.textContent = pad(s % 60);
        setTimeout(tick, 1000 - (Date.now() % 1000));
      })();
    }
  }

  function initForm(f) {
    var msg = f.querySelector('.mc-form__msg'), input = f.querySelector('input[type=email]'), btn = f.querySelector('button');
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = (input.value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { msg.textContent = 'Please enter a valid email address.'; input.focus(); return; }
      var list = f.getAttribute('data-list');
      if (!list) { msg.textContent = 'Sign-up is not connected yet. Add the Klaviyo list ID in Theme settings > M22 Challenge.'; return; }
      btn.disabled = true; msg.textContent = 'Signing you up…';
      fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(f.getAttribute('data-company')), {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2024-10-15' },
        body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: f.getAttribute('data-source'), profile: { data: { type: 'profile', attributes: { email: email } } } }, relationships: { list: { data: { type: 'list', id: list } } } } })
      }).then(function (r) {
        if (!r.ok) throw r;
        f.classList.add('is-done'); msg.textContent = "Almost there. Check your inbox and tap Confirm to join the list.";
      }).catch(function () {
        btn.disabled = false; msg.textContent = 'Something went wrong. Please try again.';
      });
    });
  }

  function initTabs(root) {
    var tabs = root.querySelectorAll('[role=tab]');
    function sel(t) {
      tabs.forEach(function (x) {
        var on = x === t; x.setAttribute('aria-selected', on); x.tabIndex = on ? 0 : -1;
        var p = document.getElementById(x.getAttribute('aria-controls')); if (p) p.hidden = !on;
      });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { sel(t); });
      t.addEventListener('keydown', function (e) {
        var k = e.key, n = null;
        if (k === 'ArrowRight' || k === 'ArrowDown') n = tabs[(i + 1) % tabs.length];
        if (k === 'ArrowLeft' || k === 'ArrowUp') n = tabs[(i - 1 + tabs.length) % tabs.length];
        if (n) { e.preventDefault(); sel(n); n.focus(); }
      });
    });
  }

  function initAcc(root) {
    /* open the item named in the URL hash */
    function openHash() {
      var id = location.hash.slice(1); if (!id) return;
      var d = document.getElementById(id); if (d && d.tagName === 'DETAILS' && root.contains(d)) { d.open = true; setTimeout(function () { d.scrollIntoView({ block: 'start' }); }, 50); }
    }
    openHash(); window.addEventListener('hashchange', openHash);
    root.querySelectorAll('[data-mc-all]').forEach(function (b) {
      b.addEventListener('click', function () {
        var ds = root.querySelectorAll('details'), anyClosed = [].some.call(ds, function (d) { return !d.open; });
        ds.forEach(function (d) { d.open = anyClosed; });
        b.textContent = anyClosed ? 'Close all' : 'Open all';
      });
    });
  }


  /* hero video play / pause */
  function initVid(b) {
    var v = b.parentNode.querySelector('video'); if (!v) return;
    v.muted = true; v.setAttribute('playsinline', '');
    function set(p) { b.textContent = p ? '▶' : '❚❚'; b.setAttribute('aria-label', p ? 'Play background video' : 'Pause background video'); }
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { v.removeAttribute('autoplay'); v.pause(); set(true); }
    else { var pr = v.play && v.play(); if (pr && pr.catch) pr.catch(function () {}); }
    b.addEventListener('click', function () { if (v.paused) { v.play(); set(false); } else { v.pause(); set(true); } });
  }

  /* navigation: the black bar scrolls away, the nav row sticks under the M22 header when it shows; rotating messages */
  function initNav(nav) {
    var sec = nav.closest('.shopify-section'), hdr = document.querySelector('.mh'), ann = nav.querySelector('.mc-nav__ann'), ticking = false;
    var sticky = !nav.classList.contains('mc-nav--static');
    function place() {
      ticking = false;
      if (!sec) return;
      var annH = ann ? ann.offsetHeight : 0, off = 0;
      if (sticky) {
        if (hdr && !hdr.classList.contains('is-hidden')) { var r = hdr.getBoundingClientRect(); off = Math.max(0, r.bottom); }
        sec.style.top = (off - annH) + 'px';
      }
      var t = sec.getBoundingClientRect().top;
      nav.classList.toggle('is-stuck', sticky && t <= off - annH + 1 && window.scrollY > 8);
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(place); } }, { passive: true });
    window.addEventListener('resize', place); place();

    var msgs = nav.querySelectorAll('.mc-nav__msg');
    if (msgs.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var i = 0;
      setInterval(function () { msgs[i].classList.remove('is-on'); i = (i + 1) % msgs.length; msgs[i].classList.add('is-on'); }, 4500);
    }
    var cur = nav.querySelector('.mc-nav__links [aria-current]'), ul = nav.querySelector('.mc-nav__links');
    if (cur && ul && ul.scrollWidth > ul.clientWidth) ul.scrollLeft = cur.offsetLeft - 12;
  }

  function scan() {
    document.querySelectorAll('[data-mc-cta]:not([data-init])').forEach(function (el) { el.setAttribute('data-init', 1); initCta(el); });
    document.querySelectorAll('[data-mc-form]:not([data-init])').forEach(function (el) { el.setAttribute('data-init', 1); initForm(el); });
    document.querySelectorAll('[data-mc-tabs]:not([data-init])').forEach(function (el) { el.setAttribute('data-init', 1); initTabs(el); });
    document.querySelectorAll('[data-mc-acc]:not([data-init])').forEach(function (el) { el.setAttribute('data-init', 1); initAcc(el); });
    document.querySelectorAll('[data-mc-vid]:not([data-init])').forEach(function (el) { el.setAttribute('data-init', 1); initVid(el); });
    document.querySelectorAll('[data-mc-nav]:not([data-init])').forEach(function (el) { el.setAttribute('data-init', 1); initNav(el); });
  }
  if (document.readyState !== 'loading') scan(); else document.addEventListener('DOMContentLoaded', scan);
  document.addEventListener('shopify:section:load', scan);
})();
